import axios from "axios";


//const API_BASE = "http://localhost:3000";
const API_BASE = "https://srv.omdcgroup.com";

export const loginUser = async (user_id, password) => {
  try {
    const response = await axios.post(`${API_BASE}/login`, { user_id, password });
    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

export const getUserAccess = async (userId) => {
  try {
    const res = await fetch(`${API_BASE}/user-access/${userId}`);
    return await res.json();
  } catch (err) {
    console.error("Error fetching user access:", err);
    return { access: [] };
  }
};


export const getinduk = async () => {
  try {
    const response = await axios.get(`${API_BASE}/list_induk`);
    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

export const getmasteraset = async (nm_induk) => {
  try {
    const response = await axios.get(`${API_BASE}/list_aset`, {
      params: { nm_induk }
    });
    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

// 🧩 Ambil master barang sesuai grup
export const getMasterBarang = async (grup_brg, status) => {
  if (!grup_brg) {
    return { status: "error", message: "Parameter grup_brg wajib diisi" };
  }

  try {
    const response = await axios.get(`${API_BASE}/masterbarang`, {
      params: { 
        grup_brg,
        status  // kirim status
      },
    });

    return response.data;
  } catch (error) {
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};

// 🧩 Ambil daftar grup
export const getGroupBarang = async () => {
  try {
    const response = await axios.get(`${API_BASE}/groupbarang`);
    return response.data;
  } catch (error) {
    console.error("❌ Gagal mengambil group barang:", error);
    return { status: "error", message: "Tidak bisa terhubung ke server" };
  }
};


export const updateBarang = async (data) => {
  try {

    const formData = new FormData();

    formData.append("kd_brg", data.kd_brg);
    formData.append("nm_barang", data.nm_barang);
    formData.append("grup_brg", data.grup_brg || "");
    formData.append("kategory_brg", data.kategory_brg || "");
    formData.append("flag_3", data.flag_3 || "");
    formData.append("flag_4", data.flag_4 || "");
    formData.append("val_3", data.val_3 || "");
    formData.append("sts_brg", data.sts_brg);
    formData.append("val_2", data.val_2);

    if (data.gambar) {
      formData.append("gambar", data.gambar);
    }

    // 🔥 DEBUG — boleh hapus nanti
    console.log("UPLOAD DATA:");
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post(
      `${API_BASE}/updatebarang`,
      formData
      // ❌ jangan set header manual
    );

    return response.data;

  } catch (error) {

    console.error("❌ Update gagal:", error.response?.data || error);

    return {
      status: "error",
      message: error.response?.data?.message || "Tidak bisa terhubung ke server"
    };
  }
};

export const getMerkList = async () => {
  try {
    const res = await fetch(`${API_BASE}/merk`);
    return await res.json();
  } catch (err) {
    console.error("getMerkList error:", err);
    return { status: "error" };
  }
};


export const getKategoriDokterList = async () => {
  try {
    const res = await axios.get(`${API_BASE}/kategori-dokter`);
    return res.data;
  } catch (err) {
    console.error(err);
    return { status: "error" };
  }
};
export const getKategoriBarang = async () => {
  try {
    const res = await axios.get(`${API_BASE}/kategori`);
    return res.data;
  } catch (err) {
    console.error(err);
    return { status: "error" };
  }
};

export const addMaster = async (type, value, user) => {
  try {

    const endpoint = {
      merk: "add-merk",
      kategori: "add-kategori",
      dokter: "add-dokter",
      grup: "add-groupbarang",
    }[type];

    const body =
      type === "grup"
        ? { grup_brg: value, user }   // ✅ FIX DI SINI
        : { value, user };

    const res = await fetch(`${API_BASE}/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    return await res.json();

  } catch (err) {
    console.error("addMaster error:", err);
    return { status: "error" };
  }
};







